import i18n from '../../i18n';

export interface ConversationShortcutItem {
  id: string;
  label: string;
  description: string;
  insertText: string;
  commandHint?: string;
}

export interface ConversationShortcutGroup {
  id: string;
  label: string;
  items: ConversationShortcutItem[];
}

export interface ConversationTemplateShortcutData {
  id: string;
  name: string;
  content: string;
}

const toTitleCase = (value: string): string =>
  value
    .trim()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/\b\w/g, (match) => match.toUpperCase());

const truncateForDescription = (value: string): string => {
  const normalized = value.replace(/\s+/g, ' ').trim();
  if (normalized.length <= 110) {
    return normalized;
  }

  return `${normalized.slice(0, 107)}...`;
};

export const buildConversationShortcutGroups = (
  templates: ConversationTemplateShortcutData[]
): ConversationShortcutGroup[] => {
  const groups: ConversationShortcutGroup[] = [
    {
      id: 'actions',
      label: i18n.t('shortcutActions', { ns: 'conversations' }),
      items: [
        {
          id: 'create-template',
          label: i18n.t('createTemplate', { ns: 'conversations' }),
          description: i18n.t('createTemplateDescription', { ns: 'conversations' }),
          insertText: '/template create ',
          commandHint: '/template create',
        },
      ],
    },
  ];

  if (templates.length === 0) {
    return groups;
  }

  const sortedTemplates = [...templates].sort((left, right) =>
    left.name.localeCompare(right.name, undefined, { sensitivity: 'base' })
  );

  groups.push({
    id: 'templates',
    label: i18n.t('templates', { ns: 'conversations' }),
    items: sortedTemplates.map((template) => ({
      id: `template-${template.id}`,
      label: toTitleCase(template.name),
      description: truncateForDescription(template.content),
      insertText: template.content,
      commandHint: template.name,
    })),
  });

  return groups;
};